import * as analytics from 'vue-analytics';
import BaseService from './base.service';
// import langUtil, { StringKey } from '@/utils/lang.util';
// import userUtil from '@/utils/user.util';
import SettingStorage, { settingStorageJson, storageLabels } from '@/utils/settings.storage';
import { ContentType, itemList } from '@/utils/settings.options';
import store from '@/store';
import { updateStoreFromStorage } from '@/store/settings';

export default {
  async refreshWeb(timezoneOffset = new Date().getTimezoneOffset()) {
    const headers = BaseService.setupDeviceIdHeaders();
    const formData = {
      "timeZoneOffsetInMinutes": timezoneOffset,
    }
    const response = await BaseService.api().post('/device/refreshWeb', JSON.stringify(formData), {
      headers,
      withCredentials: true,
    })

    const bootResult = response && response.data ? response.data : null;

    if (bootResult) {
      // Store settings for the first time
      const storage = localStorage.getItem(storageLabels.settingStorage);
      if (storage === null) {
        const ageOption = SettingStorage.getAgeOptionId(itemList.age, {minAge: 3, maxAge: 8});
        const languageOption = SettingStorage.getOptionId(itemList.language, bootResult.activeLanguage);
        const timeOption = SettingStorage.getOptionId(itemList.time, 90);
        const contentOption = SettingStorage.getOptionId(itemList.content, 0);
        settingStorageJson.push({ item: { type: itemList.age, option: ageOption } });
        settingStorageJson.push({ item: { type: itemList.language, option: languageOption } });
        settingStorageJson.push({ item: { type: itemList.time, option: timeOption } });
        settingStorageJson.push({ item: { type: itemList.content, option: contentOption } });
        settingStorageJson.push({ item: { type: itemList.other, option: 1, play: true } });
        localStorage.setItem(storageLabels.settingStorage, JSON.stringify({ settingStorageJson }));
        updateStoreFromStorage(store);
      }

      if (bootResult.isSubscribed) {
        analytics.event('user', 'premium');
      } else {
        analytics.event('user', 'visitor');
      }
    }
    return Promise.resolve(bootResult)
  },
  // async updateKid(age, kidId) {
  //   const kidIdentifier = kidId ? kidId : userUtil.getKidId();
  //   const headers = BaseService.setupDeviceIdHeaders();
  //   const response = await BaseService.api.post(`/kid/${kidIdentifier}/update`, { age }, { headers });

  //   return response && response.status === 200;
  // },
  async updateLanguage(languageId) {
    const headers = BaseService.setupDeviceIdHeaders();
    const response = await BaseService.api().post('/language/set', { languageId }, { headers });

    return response && response.status === 200;
  },
  // async unsubscribe() {
  //   const userId = userUtil.getUserId();
  //   const headers = BaseService.setupDeviceIdHeaders();
  //   try {
  //     await BaseService.api.post('/subscription/cancel', userId ? { userId } : null, { headers });
  //     return langUtil.getLang().t(StringKey.UnsubscribeSuccess);
  //   } catch (error) {
  //     if (error && error.response.data && error.response.data.errorCode === 3) {
  //       return langUtil.getLang().t(StringKey.UnsubscribeAlreadyCancelled);
  //     } else {
  //       return langUtil.getLang().t(StringKey.UnsubscribeError);
  //     }
  //   }
  // },
};
